import type { ApiFn } from '@/api/factory/base/api';
import { useMakeQuery } from '@/api/use-make-query';
import { QUERY_KEYS } from '@/features/footer/api/query/query-keys';
import type { FooterResponse } from '@/features/footer/api/types';

export const getFooter = () => {
  const apiFn: ApiFn<FooterResponse> = (api) => api.get('/footer');

  return {
    apiFn,
    queryKey: [QUERY_KEYS.FOOTER],
  };
};

export const useFooter = () => {
  return useMakeQuery(getFooter());
};
